// extracted by mini-css-extract-plugin
module.exports = {"navbarRoot":"NavBar_navbarRoot__1zUIU"};